/** JerryMark's catalog lockup: official happy mark, wordmark and descriptor. */
export const BrandLockup = ({ compactAtTablet = false }: { compactAtTablet?: boolean }) => (
  <span className="app-brand-lockup">
    <span className="app-brand-lockup-mark" aria-hidden="true" />
    <span className={`text-left${compactAtTablet ? " md:hidden xl:block" : ""}`}>
      <span className="block font-[var(--ds-font-display)] text-[32px] font-medium leading-none tracking-[-0.04em] text-[var(--ds-ink)]">HeyJerry!</span>
      <span className="mt-1 block text-[10px] font-medium uppercase leading-[14px] tracking-[0.18em] text-[var(--ds-ink-muted)]">FINANCE OS</span>
    </span>
  </span>
);
